export default __webpack_public_path__ + "static/media/Services-6.b14012c8.jpg";